import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const ShowMoreButton = styled.button`
    display: flex;
    align-items: center;

    border: none;
    color: var(--purple-lighter);
    background: transparent;
    
    font-size: 1rem;
    padding: 0.25rem;

    &:hover{
        text-decoration: underline;
    }
`;
